import { render, staticRenderFns } from "./VeHrPeixunPersonalList.vue?vue&type=template&id=b958b55a&scoped=true"
import script from "./VeHrPeixunPersonalList.vue?vue&type=script&lang=js"
export * from "./VeHrPeixunPersonalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b958b55a",
  null
  
)

export default component.exports